import { TableCell, TableRow } from "@mui/material";
import type { FunctionComponent } from "react";
import { NoSearchResults } from "../NoSearchResults";

export interface NoSearchResultsTableRowProps {
  onFilterReset?: () => void;
}

export const NoSearchResultsTableRow: FunctionComponent<
  NoSearchResultsTableRowProps
> = ({ onFilterReset }) => {
  return (
    <TableRow>
      <TableCell align="center" colSpan={1000}>
        <NoSearchResults onFilterReset={onFilterReset} />
      </TableCell>
    </TableRow>
  );
};
